import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import {
  Table,
  Dropdown,
  Modal,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
function Quotes() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const [catList, setCatList] = useState([]);
  const [addStatus, setAddStatus] = useState(false);
  const [removeFaq, setRemoveFaq] = useState(false);
  const [spinner, setSpinner] = useState(true);

  const [allQuotes, setAllQuotes] = useState([]);
  const [quotesId, setQuotesId] = useState("");

  const searchObject = ["Rider", "Onboard", "Customer"];
  const [category, setCategory] = useState("Rider");
  const [quotes, setQuotes] = useState("");
  const [categoryUnId, setCategoryUnId] = useState("");
  const [qts, setQts] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function getAllQuotes() {
    axios.get(Baseurl.baseurl + "/go-ui/get-all-quotes").then((response) => {
      if (response.data.status) {
        setAllQuotes(response.data.quotes);
      }

      setSpinner(false);
    });
  }
  function getCategory() {
    let cat = [];
    axios
      .get(Baseurl.baseurl + `/go-ui/get-category`)
      .then((res) => {
        res.data.categories.map((val) => {
          cat.push(val.Category);
        });
        cat.push("Go_Home");
        cat.push("Go_Home_Sub");
        setCatList(cat);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getCategory();
    getAllQuotes();
  }, []);
  const deleteParticularQuote = () => {
    let faqData = {
        quoteId: quotesId,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/delete-perticular-quotes-by-category/${categoryId}`, faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getAllQuotes();
        setShow1(false);
      });
  };
  const deleteQtsCategory = () => {
    axios({
      method: "delete",
      url: Baseurl.baseurl + `/go-ui/delete-quotes-by-category/${categoryId}`,
      headers: {},
    }).then((response) => {
      if (response.data.status) {
        swal("Deleted", response.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
      } else {
        swal("Oops", response.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }
      getAllQuotes();
      setShow1(false);
    });
  };

  function addQts() {
    let line = {
      Quotes: quotes,
    };
    setQts(
      (oldArray) => oldArray.concat(line),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
    setQuotes("");
  }
  function addQuotesData() {
    let faqData = {
      Category: category,
      QuotesDetails: qts,
    };
    let strFaqData = {
      data: JSON.stringify(faqData),
    };
    axios
      .post(Baseurl.baseurl + `/go-ui/create-quotes`, strFaqData)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow(false);
        getAllQuotes();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function addQtsToCategory() {
    let faqData = {
        quotes: quotes,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/add-quotes-to-category/${categoryUnId}`, faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow(false);
        getAllQuotes();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateParticularQuotes() {
    let quotData = {
      quotes: quotes,
      quoteId: quotesId,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-ui/update-quotes-by-category/${categoryId}`,
        quotData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow2(false);
        getAllQuotes();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <div className="col-16">
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body>
          {removeFaq ? (
            <h4>are you sure! want to delete this Quote</h4>
          ) : (
            <h4>are you sure! want to delete this Category</h4>
          )}
        </Modal.Body>
        <Modal.Footer>
          {removeFaq ? (
            <Button variant="primary" onClick={deleteParticularQuote}>
              Delete
            </Button>
          ) : (
            <Button variant="primary" onClick={deleteQtsCategory}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Body>
          <div className=" mb-3">
            <label>Quotes</label>
            <input
              value={quotes}
              type="text"
              className="form-control"
              placeholder="enter Quotes"
              onChange={(e) => {
                setQuotes(e.target.value);
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              updateParticularQuotes();
            }}
            className="btn btn-primary"
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {!addStatus && (
            <div className=" mb-3">
              <label>Category</label>

              <select
                className="form- col-sm-12 text-primary p-2"
                id="val-skill"
                name="val-skill"
                placeholder="Select Search Item"
                defaultValue={category}
                onChange={(event) => {
                  setCategory(event.target.value);
                }}
              >
                {catList &&
                  catList.map((val) => <option value={val}>{val}</option>)}
              </select>
            </div>
          )}

          <div className=" mb-3">
            <label>Quotes</label>
            <input
              value={quotes}
              type="text"
              className="form-control"
              maxLength={category==='Go_Home'&&20}
              placeholder="enter Quotes"
              onChange={(e) => {
                setQuotes(e.target.value);
              }}
            />
          </div>
          {!addStatus &&(
             <button
             onClick={() => {
               addQts();
             }}
             className="btn btn-primary float-right mt-3"
           >
             Add
           </button>
          )}
         

          {qts.length !== 0 && (
            <Table responsive id="myTable">
              <thead>
                <tr>
                  <th>
                    <strong>Quotes</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {qts &&
                  qts.map((val) => (
                    <tr>
                      <td>{val.Quotes}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          {qts.length !== 0 && !addStatus && (
            <Button
              variant="primary"
              onClick={() => {
                addQuotesData();
              }}
            >
              Add FAQ
            </Button>
          )}
          {addStatus && (
            <Button
              variant="primary"
              onClick={() => {
                addQtsToCategory();
              }}
            >
              Update FAQ
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <h4 className="card-title text-white"></h4>
          <button
            onClick={() => {
              setAddStatus(false);
              setShow(true);
              setQts([]);
            }}
            className="btn btn-primary"
          >
            Add Quotes
          </button>
        </div>
        <div className="card-body">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table responsive id="myTable" className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong>SLNO.</strong>
                  </th>
                  <th>
                    <strong> Category</strong>
                  </th>
                  <th>
                    <strong>Quotes</strong>
                  </th>

                  <th>
                    <strong></strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {allQuotes.map((p, i) => (
                  <tr key={p._id}>
                    <td>{i + 1}</td>
                    <td>{p.Category}</td>
                    {p.QuotesDetails.map((g) => {
                      return (
                        <>
                          <Table className="text-white ">
                            <tbody>
                              <tr>
                                <td>{g.Quotes}</td>
                                <td>
                                  {" "}
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="warning"
                                      className="light sharp i-false"
                                    >
                                      {svg1}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                          setShow2(true);
                                          setQuotes(g.Quotes);
                                          setQuotesId(g._id);
                                          setCategoryId(p.Category);
                                        }}
                                      >
                                        Update
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        onClick={() => {
                                          setShow1(true);
                                          setRemoveFaq(true);
                                          setQuotesId(g._id);
                                          setCategoryId(p.Category);
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>

                                <br />
                              </tr>
                            </tbody>
                          </Table>
                        </>
                      );
                    })}
                    <td className="ml-5">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="warning"
                          className="light sharp i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setAddStatus(true);
                              setShow(true);
                              setCategoryId(p.Category);
                              setCategoryUnId(p._id);
                            }}
                          >
                            Add Quotes
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              setShow1(true);
                              setRemoveFaq(false);
                              setCategoryId(p.Category);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {allQuotes.length === 0 && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              No Faq
            </Alert>
          )}
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">...</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button type="button" class="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quotes;
